<script>
import MainButton from "@/components/helpers/MainButton.vue";
import MainModal from "@/components/helpers/MainModal.vue";

export default {
  name: "NotMainAccountModal",
  components: { MainButton, MainModal },

  emits: ["close"],

  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  watch: {
    isShowModal() {
      if (!this.isShowModal) {
      }
    },
  },

  methods: {
    closeModal() {
      if (!this.isBuyCertLoading) {
        this.$emit("close");
      }
    },
  },
};
</script>

<template>
  <MainModal :show-modal="isShowModal" @close="closeModal">
    <div class="not-main-account-modal">
      <h2>Требуется основной аккаунт</h2>

      <p>
        Доступ к покупке и обновлению тарифов предоставляется только через
        основной аккаунт. Пожалуйста, вернитесь в учетную запись,
        зарегистрированную в вашей стране
      </p>

      <MainButton title="Понятно" color="dark" @click="closeModal" />
    </div>
  </MainModal>
</template>

<style lang="scss">
.not-main-account-modal {
  width: 518px;
  border-radius: 16px;
  background: var(--background-light-second, #f8f8f8);
  padding: 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    @include title-3;
    color: var(--text-dark-primary, #212121);
    margin-bottom: 26px;
  }

  p {
    color: var(--text-dark-primary, #212121);
    @include body-1;
  }
}
</style>
